// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"62b910d9","453":"a4a288f2"}[chunkId] + ".chunk.js";
};